import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Coverage section of the pack (coverage/usecases.yaml) — parser + view
 * models + pure presentation helpers.
 *
 * RULE ZERO (backend handoff README): the viewer is a pure renderer.
 * Never join against tests/*, never compute scores/percentages/statuses
 * client-side — everything renderable is a fact row or a precomputed
 * number under `rollup:`, sealed with the config that produced it.
 * Aspects are an OPEN map (more may appear; render dynamically); unknown
 * keys are ignored everywhere; `rollup_version` gates breaking changes
 * (v1 today). Packs without coverage/ parse to null — empty state.
 */

import { load, JSON_SCHEMA } from 'js-yaml';
var yamlParse = function yamlParse(text) {
  return load(text, {
    schema: JSON_SCHEMA
  });
};
function asRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v) ? v : null;
}
var asString = function asString(v) {
  return typeof v === 'string' && v !== '' ? v : undefined;
};
var asNumber = function asNumber(v) {
  return typeof v === 'number' && Number.isFinite(v) ? v : undefined;
};
var asStringArray = function asStringArray(v) {
  return Array.isArray(v) ? v.filter(function (x) {
    return typeof x === 'string';
  }) : [];
};
var asRecordArray = function asRecordArray(v) {
  return Array.isArray(v) ? v.map(asRecord).filter(function (r) {
    return r !== null;
  }) : [];
};

// ── View models ────────────────────────────────────────────────────────────

// ── Parser ──────────────────────────────────────────────────────────────────

function toAc(r) {
  var _asString;
  var id = asString(r.id);
  if (!id) return null;
  var ea = asRecord(r.expected_answer);
  var scope = asRecord(r.scope);
  return {
    id: id,
    text: asString(r.text),
    risk: asString(r.risk),
    scope: scope ? {
      type: asString(scope.type),
      ref: asString(scope.ref)
    } : undefined,
    coveredBy: asStringArray(r.covered_by),
    linkType: asString(r.link_type),
    execution: asString(r.execution),
    fresh: asString(r.fresh),
    expectedAnswer: ea ? {
      kind: asString(ea.kind),
      statement: asString(ea.statement),
      operator: asString(ea.operator),
      operand: (_asString = asString(ea.operand)) !== null && _asString !== void 0 ? _asString : asNumber(ea.operand)
    } : undefined,
    satisfiedBy: asRecordArray(r.satisfied_by).map(function (s) {
      var _asString2;
      return {
        test: (_asString2 = asString(s.test)) !== null && _asString2 !== void 0 ? _asString2 : '',
        step: asString(s.step)
      };
    }).filter(function (s) {
      return s.test !== '';
    }),
    executions: asRecordArray(r.executions).map(function (e) {
      return {
        executionId: asString(e.execution_id),
        ts: asString(e.ts),
        verdict: asString(e.verdict),
        staleAtRun: e.stale_at_run === true,
        oracleMode: asString(e.oracle_mode),
        viaParent: asString(e.via_parent)
      };
    })
  };
}
function toUsecase(r) {
  var id = asString(r.id);
  if (!id) return null;
  var provenance = asRecord(r.provenance);
  return {
    id: id,
    title: asString(r.title),
    description: asString(r.description),
    actors: asStringArray(r.actors),
    value: asString(r.value),
    risk: asString(r.risk),
    status: asString(r.status),
    sources: asRecordArray(r.sources).map(function (s) {
      var _asString3;
      return {
        id: (_asString3 = asString(s.id)) !== null && _asString3 !== void 0 ? _asString3 : '',
        mediaType: asString(s.media_type),
        cid: asString(s.cid),
        file: asString(s.file)
      };
    }).filter(function (s) {
      return s.id !== '';
    }),
    staleSources: asStringArray(r.stale_sources),
    derivedFrom: provenance ? asString(provenance.derived_from) : undefined,
    scenarios: asRecordArray(r.scenarios).map(function (s) {
      var _asString4;
      return {
        id: (_asString4 = asString(s.id)) !== null && _asString4 !== void 0 ? _asString4 : '',
        caseType: asString(s.case_type),
        intent: asString(s.intent),
        exercises: asStringArray(s.exercises)
      };
    }),
    acceptanceCriteria: asRecordArray(r.acceptance_criteria).map(toAc).filter(function (ac) {
      return ac !== null;
    })
  };
}
function toAspect(r) {
  var _asRecord, _asRecord2, _asRecord3, _asRecord4;
  var acs = {};
  var acsRaw = (_asRecord = asRecord(r.acs)) !== null && _asRecord !== void 0 ? _asRecord : {};
  for (var _i = 0, _Object$entries = Object.entries(acsRaw); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      id = _Object$entries$_i[0],
      v = _Object$entries$_i[1];
    var row = asRecord(v);
    if (!row) continue;
    acs[id] = {
      score: asNumber(row.score),
      verified: row.verified === true,
      passes: asNumber(row.passes),
      counted: asNumber(row.counted)
    };
  }
  var usecases = {};
  var ucRaw = (_asRecord2 = asRecord(r.usecases)) !== null && _asRecord2 !== void 0 ? _asRecord2 : {};
  for (var _i2 = 0, _Object$entries2 = Object.entries(ucRaw); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
      _id = _Object$entries2$_i[0],
      _v = _Object$entries2$_i[1];
    var _row = asRecord(_v);
    if (!_row) continue;
    usecases[_id] = {
      status: asString(_row.status),
      pct: asNumber(_row.pct)
    };
  }
  var summary = (_asRecord3 = asRecord(r.summary)) !== null && _asRecord3 !== void 0 ? _asRecord3 : {};
  return {
    config: (_asRecord4 = asRecord(r.config)) !== null && _asRecord4 !== void 0 ? _asRecord4 : {},
    acs: acs,
    usecases: usecases,
    summary: {
      coveragePct: asNumber(summary.coverage_pct),
      acsVerified: asString(summary.acs_verified),
      usecasesCovered: asString(summary.usecases_covered),
      uncovered: asNumber(summary.uncovered)
    }
  };
}

/** Parse coverage/usecases.yaml. Null = absent/unreadable → empty state
 * (packs sealed before coverage shipped have no coverage/ at all). */
export function parseCoverage(yamlText) {
  var _asRecord5, _asRecord6;
  var doc;
  try {
    doc = asRecord(yamlParse(yamlText));
  } catch (_unused) {
    return null;
  }
  if (!doc || !Array.isArray(doc.usecases)) return null;
  var rollup = (_asRecord5 = asRecord(doc.rollup)) !== null && _asRecord5 !== void 0 ? _asRecord5 : {};
  var aspectsRaw = (_asRecord6 = asRecord(rollup.aspects)) !== null && _asRecord6 !== void 0 ? _asRecord6 : {};
  var aspects = {};
  for (var _i3 = 0, _Object$entries3 = Object.entries(aspectsRaw); _i3 < _Object$entries3.length; _i3++) {
    var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
      name = _Object$entries3$_i[0],
      v = _Object$entries3$_i[1];
    var r = asRecord(v);
    if (r) aspects[name] = toAspect(r);
  }
  return {
    usecases: asRecordArray(doc.usecases).map(toUsecase).filter(function (u) {
      return u !== null;
    }),
    gaps: asRecordArray(doc.gaps).map(function (g) {
      var _asString5;
      return {
        ref: (_asString5 = asString(g.ref)) !== null && _asString5 !== void 0 ? _asString5 : '',
        kind: asString(g.kind),
        risk: asString(g.risk),
        question: asString(g.question)
      };
    }).filter(function (g) {
      return g.ref !== '';
    }),
    rollupVersion: asNumber(rollup.rollup_version),
    staleSources: asNumber(rollup.stale_sources),
    highRiskGaps: asNumber(rollup.high_risk_gaps),
    aspects: aspects
  };
}

// ── Presentation helpers (no score math — buckets are display only) ───────

/** The summary band's segmented-bar rule, verbatim from the handoff:
 * verified → green; else execution failed OR nothing covers it → red;
 * else → amber (weak / stale / no-signal). */
export function acBucket(ac, aspectAcs) {
  var _aspectAcs$ac$id;
  if ((_aspectAcs$ac$id = aspectAcs[ac.id]) !== null && _aspectAcs$ac$id !== void 0 && _aspectAcs$ac$id.verified) return 'verified';
  if (ac.execution === 'failed' || ac.coveredBy.length === 0) {
    return 'uncovered';
  }
  return 'weak';
}
var OPERATOR_GLYPHS = {
  lte: '≤',
  gte: '≥',
  lt: '<',
  gt: '>',
  equals: '='
};

/** "count · lte · 300" → "≤ 300"; presence answers are just the statement
 * (already shown as the AC text), so they add nothing. */
export function expectedAnswerLabel(ea) {
  var _OPERATOR_GLYPHS$ea$o;
  if (!ea || ea.operator === undefined || ea.operand === undefined) {
    return null;
  }
  var glyph = (_OPERATOR_GLYPHS$ea$o = OPERATOR_GLYPHS[ea.operator]) !== null && _OPERATOR_GLYPHS$ea$o !== void 0 ? _OPERATOR_GLYPHS$ea$o : ea.operator;
  return "".concat(glyph, " ").concat(ea.operand);
}
/** The Context drawer's Sources list: one entry per source id across all
 * use-cases (first occurrence wins the metadata). */
export function uniqueSources(usecases) {
  var byId = new Map();
  var _iterator = _createForOfIteratorHelper(usecases),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var uc = _step.value;
      var staleSet = new Set(uc.staleSources);
      var _iterator2 = _createForOfIteratorHelper(uc.sources),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var src = _step2.value;
          var hit = byId.get(src.id);
          if (hit) {
            if (!hit.usedIn.includes(uc.id)) hit.usedIn.push(uc.id);
            if (staleSet.has(src.id)) hit.stale = true;
          } else {
            byId.set(src.id, _objectSpread(_objectSpread({}, src), {}, {
              usedIn: [uc.id],
              stale: staleSet.has(src.id)
            }));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return _toConsumableArray(byId.values());
}

/** "text/markdown" → "markdown" — the meta line's short type label. */
export function mediaShort(mediaType) {
  if (!mediaType) return null;
  var sub = mediaType.split('/')[1];
  return sub && sub !== '' ? sub : mediaType;
}

/** Use-case-scoped ACs are the INVARIANTS — they hold across the whole
 * use-case rather than one scenario (the backend's gap kind
 * `invariant-unexercised` names them the same way). Scenario-scoped ACs
 * are ordinary criteria. */
export function isInvariant(ac) {
  var _ac$scope;
  return ((_ac$scope = ac.scope) === null || _ac$scope === void 0 ? void 0 : _ac$scope.type) === 'usecase';
}

/** Aspect display order: lenient (the display default) first, then the
 * rest in authored order — the map is open, never enumerate names. */
export function aspectNames(doc) {
  var names = Object.keys(doc.aspects);
  return [].concat(_toConsumableArray(names.filter(function (n) {
    return n === 'lenient';
  })), _toConsumableArray(names.filter(function (n) {
    return n !== 'lenient';
  })));
}